namespace Matrix.Data {
    export interface PartyRolePartyForm {
        PartyCode: Serenity.StringEditor;
        RoleCode: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PartyRolePartyForm extends Serenity.PrefixedContext {
        static formKey = 'Data.PartyRoleParty';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartyRolePartyForm.init)  {
                PartyRolePartyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(PartyRolePartyForm, [
                    'PartyCode', w0,
                    'RoleCode', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
